import { useQuery } from "@tanstack/react-query";
import { courseKeys } from "@/lib/query";

type CourseProgress = {
  id: string;
  userId: string;
  courseId: string | null;
  startedAt: string;
  completedAt: string | null;
  currentModule: number;
  currentCard: number;
  progressData: Record<string, unknown>;
  updatedAt: string;
};

export type CourseWithProgress = {
  id: string;
  slug: string;
  title: string;
  description: string;
  totalModules: number;
  isPublished: boolean;
  isFeatured: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  progress: CourseProgress | null;
};

export type FeaturedCourse = {
  id: string;
  slug: string;
  title: string;
  description: string;
  totalModules: number;
};

async function fetchFeaturedCourse(): Promise<FeaturedCourse | null> {
  const res = await fetch("/api/public/featured-course");
  if (!res.ok) return null;
  const json = (await res.json()) as { data: FeaturedCourse | null };
  return json.data;
}

export function useFeaturedCourse() {
  return useQuery({
    queryKey: ["featured-course"],
    queryFn: fetchFeaturedCourse,
  });
}

async function fetchCourses(): Promise<CourseWithProgress[]> {
  const res = await fetch("/api/courses");
  if (!res.ok) throw new Error("Failed to load courses");
  const json = (await res.json()) as { data: CourseWithProgress[] };
  return json.data;
}

export function useCourses() {
  return useQuery({
    queryKey: courseKeys.list(),
    queryFn: fetchCourses,
  });
}
